var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 138,
    viewBox: "0 0 147 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.73 120C100.72 120 123.411 97.2541 123.411 69.1954C123.411 41.1367 100.72 18.3906 72.73 18.3906C44.7396 18.3906 22.0488 41.1367 22.0488 69.1954C22.0488 97.2541 44.7396 120 72.73 120Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4073 36.2812H107.503C110.358 36.2812 112.602 38.5302 112.602 41.3924V87.086C112.602 89.9483 110.358 92.1972 107.503 92.1972H35.4073C32.552 92.1972 30.3086 89.9483 30.3086 87.086V41.3924C30.3086 38.5302 32.654 36.2812 35.4073 36.2812Z",
    fill: "#DAE2EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.639 56.5521C133.219 55.1048 133.33 52.6478 131.886 51.0641C130.442 49.4804 127.991 49.3698 126.411 50.817C124.831 52.2643 124.721 54.7213 126.165 56.305C127.609 57.8887 130.06 57.9993 131.639 56.5521Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4438 23.4731C44.7828 23.0369 45.5154 21.5951 45.0802 20.2528C44.645 18.9106 43.2068 18.1762 41.8678 18.6124C40.5288 19.0487 39.7962 20.4904 40.2314 21.8327C40.6666 23.1749 42.1048 23.9094 43.4438 23.4731Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4601 15.2217C49.4175 15.2217 50.1937 14.4436 50.1937 13.4839C50.1937 12.5241 49.4175 11.7461 48.4601 11.7461C47.5027 11.7461 46.7266 12.5241 46.7266 13.4839C46.7266 14.4436 47.5027 15.2217 48.4601 15.2217Z",
    fill: "url(#paint0_linear_4491_162744)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.856 39.5524C131.757 39.5524 132.488 38.8201 132.488 37.9168C132.488 37.0135 131.757 36.2812 130.856 36.2812C129.955 36.2812 129.225 37.0135 129.225 37.9168C129.225 38.8201 129.955 39.5524 130.856 39.5524Z",
    fill: "url(#paint1_linear_4491_162744)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8376 15.3117C91.2949 14.8928 91.3268 14.1815 90.9089 13.7231C90.491 13.2647 89.7815 13.2327 89.3241 13.6516C88.8668 14.0705 88.8349 14.7818 89.2528 15.2402C89.6707 15.6987 90.3802 15.7307 90.8376 15.3117Z",
    fill: "#EAEEF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.049 65.5984V88.0874C114.049 90.9497 111.704 93.4032 108.746 93.4032H34.6112C31.7559 93.4032 29.3086 91.0519 29.3086 88.0874V63.6562",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4491_162744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.653 53H84.3378C82.0689 53 79.8783 53.7828 78.1571 55.1915L72.0544 60.2002C70.3332 61.6088 68.1426 62.3913 65.8737 62.3913H39.3507C36.6906 62.3913 34.5 64.5828 34.5 67.2436C34.5 67.4784 34.5001 67.7131 34.5783 67.9479L39.4291 93.774C39.8202 96.2001 41.8544 98 44.2798 98H100.768C103.193 98 105.227 96.2784 105.619 93.8523L112.426 58.5566C112.895 55.8957 111.095 53.4696 108.435 53C108.201 53 107.888 53 107.653 53Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4491_162744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.229 46.0742H87.8403C84.8831 46.0742 82.0279 47.0967 79.7845 48.9368L71.8304 55.4789C69.587 57.3189 66.7318 58.341 63.7746 58.341H29.2052C25.738 58.341 22.8828 61.2034 22.8828 64.679C22.8828 64.9857 22.8829 65.2922 22.9849 65.5989L29.3072 99.3325C29.8171 102.501 32.4684 104.852 35.6296 104.852H109.255C112.416 104.852 115.067 102.604 115.577 99.4348L124.449 53.3321C125.061 49.8566 122.716 46.6876 119.248 46.0742C118.942 46.0742 118.535 46.0742 118.229 46.0742Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3881 81.0344C61.1903 81.0344 62.6512 79.5696 62.6512 77.763C62.6512 75.9564 61.1903 74.4922 59.3881 74.4922C57.5859 74.4922 56.125 75.9564 56.125 77.763C56.125 79.5696 57.5859 81.0344 59.3881 81.0344Z",
    fill: "#1C3754"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0873 80.9328C86.8895 80.9328 88.3505 79.4686 88.3505 77.662C88.3505 75.8554 86.8895 74.3906 85.0873 74.3906C83.2851 74.3906 81.8242 75.8554 81.8242 77.662C81.8242 79.4686 83.2851 80.9328 85.0873 80.9328Z",
    fill: "#1C3754"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2432 57.3391C64.6741 50.388 63.8583 41.9035 66.2037 34.339C68.5491 26.7745 73.9537 20.2322 80.786 16.5522C82.9274 15.4277 85.2728 14.5077 87.7202 14.4055C90.1676 14.3033 92.717 15.1211 94.3485 17.0633C95.9801 18.9033 96.2861 21.8678 94.9604 23.9123C93.5327 25.8545 90.7794 26.57 88.434 26.0589C84.763 25.3434 81.7037 22.4811 80.786 19.0056C79.8682 15.53 81.0919 11.4411 83.8452 9.08993C85.6807 7.45436 88.1281 6.63658 90.4735 5.92102C101.691 2.64988 113.826 2.24099 125.247 4.69434",
    stroke: "#C9D4E2",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3806 84.5273H69.1602V86.0607H75.3806V84.5273Z",
    fill: "#1C3754"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.265 2.0347C131.163 3.56805 131.061 4.89695 129.939 5.20361C128.817 5.51028 128.307 4.48805 127.593 3.05693C126.88 1.72804 127.288 0.399137 128.511 0.092468C129.735 -0.214201 131.468 0.194691 131.265 2.0347Z",
    fill: "#DAE2EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.143 9.18867C130.449 7.34865 130.755 6.42865 129.735 5.91753C128.614 5.40642 127.9 6.32642 126.778 7.5531C125.758 8.67755 126.37 10.2109 127.39 10.722C128.512 11.3353 129.837 10.722 130.143 9.18867Z",
    fill: "#DAE2EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.467 5.92058C131.365 6.63614 130.855 7.14725 130.142 7.24948C129.836 7.24948 129.53 7.24948 129.122 7.24948C127.694 7.04503 126.572 6.12502 126.674 5.20502C126.776 4.28501 128.102 3.7739 129.632 3.97834C129.938 3.97834 130.244 4.08056 130.447 4.18279C131.161 4.38723 131.569 5.10279 131.467 5.92058C131.467 5.81835 131.467 5.92058 131.467 5.92058Z",
    fill: "#1C3754"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 34.0292C19.9102 32.2914 19.9102 30.6558 21.1338 30.1447C22.4595 29.6336 23.1733 30.8603 24.0911 32.4958C25.0089 34.0292 24.601 35.5625 23.2753 36.0736C22.1536 36.5848 19.9102 36.2781 19.9102 34.0292Z",
    fill: "#DAE2EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6223 25.6467C20.4183 27.7934 20.1124 28.9178 21.4381 29.4289C22.7637 29.94 23.4776 28.8156 24.7012 27.18C25.721 25.7489 25.0072 24.0111 23.6815 23.5C22.3558 22.9889 20.8262 23.9089 20.6223 25.6467Z",
    fill: "#DAE2EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 29.6334C19.5 28.8157 20.1118 28.2023 20.8257 28.1001C21.1316 27.9979 21.5395 27.9979 21.9474 28.1001C23.579 28.2023 24.9046 29.1223 24.8027 30.1446C24.7007 31.1668 23.375 31.8824 21.7434 31.6779C21.4375 31.6779 21.1316 31.5757 20.8257 31.4735C20.0099 31.269 19.5 30.4512 19.5 29.6334Z",
    fill: "#1C3754"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.332 29.9414C36.8354 29.9414 56.2105 36.0748 56.5164 58.4616",
    stroke: "#C9D4E2",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4491_162744",
    x: 24.5,
    y: 34,
    width: 98,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4491_162744"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4491_162744",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4491_162744",
    x: 0.882812,
    y: 35.0742,
    width: 145.664,
    height: 102.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4491_162744"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4491_162744",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4491_162744",
    x1: 46.7789,
    y1: 13.4405,
    x2: 50.1495,
    y2: 13.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4491_162744",
    x1: 129.281,
    y1: 37.9576,
    x2: 132.447,
    y2: 37.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.dad8958cb4d8643132ae4191a8e8ef65.svg";
export { ForwardRef as ReactComponent };